module.exports = __webpack_public_path__ + "images/mdj/members/common/common_icon05-3641a15af3332b9add58e92d882e9e1f.png";